import Checkbox from 'components/Checkbox/Checkbox';
import React, { useState } from 'react';
import './chargeTypeRadio.scss';

type ChargeTypeRadioProps = {
  chargeType: any;
  chargeTypes: any;
  onChange: Function;
  index: number;
  isFirmAdmin: boolean;
};

const ChargeTypeRadio: React.FC<ChargeTypeRadioProps> = props => {
  const [selectedChargeType, setSelectedChargeType] = useState(
    props.chargeType || 3
  );

  const selectStepped = () => {
    setSelectedChargeType(2);
    props.onChange(props.index, 2);
  };
  const selectTiered = () => {
    setSelectedChargeType(1);
    props.onChange(props.index, 1);
  };
  const selectFixed = () => {
    setSelectedChargeType(3);
    props.onChange(props.index, 3);
  };

  return (
    <div className="radioButtonContainer">
      <Checkbox
        onClick={() => selectStepped()}
        label={'Stepped'}
        isChecked={selectedChargeType === 2}
        disabled={!props.isFirmAdmin}
      />
      <Checkbox
        onClick={() => selectTiered()}
        label={'Tiered'}
        isChecked={selectedChargeType === 1}
        disabled={!props.isFirmAdmin}
      />
      <Checkbox
        onClick={() => selectFixed()}
        label={'Fixed'}
        isChecked={selectedChargeType === 3}
        disabled={!props.isFirmAdmin}
      />
    </div>
  );
};

export default ChargeTypeRadio;
